/* global SERVICE_MARKETING_URL fetch */
import { warn, trace } from './log';

const serviceMarketingPublicRoot = `${SERVICE_MARKETING_URL}/api/marketing`;
const checkCampaignEndpoint = `${serviceMarketingPublicRoot}/check`;

export const checkCampaign = async (payload = {}) => {
  trace(`checkCampaign > calling ${checkCampaignEndpoint}`);
  const response = await fetch(checkCampaignEndpoint, {
    body: JSON.stringify(payload),
    method: 'POST',
    credentials: 'same-origin'
    // headers: { 'x-csrf-token': window.Cookies.get('csrf') }
  });

  if (response.ok) {
    trace(`checkCampaign > response is ok`);
    return response.json();
  }

  warn('checkCampaign: response not ok');
  throw new Error();
};
